import React from 'react';

export const PoweredByLink: React.FC = () => {
  return (
    <div
      style={{ color: '#999', fontSize: '12px' }}
      className="simple-store-locator-powered-by"
    >
      Powered by{' '}
      <a
        href={`https://apps.shopify.com/simple-store-locator?utm_medium=poweredby&utm_source=${window.sslShopifyShop}`}
        style={{ color: '#999' }}
        target="_blank"
        rel="noreferrer"
      >
        Simple Store Locator
      </a>
    </div>
  );
};
